import { createFileRoute } from '@tanstack/react-router';
import { CreateDepartmentsBulkPage } from '@/pages/organization/departments/bulk-upload/CreateDepartmentsBulkPage';

export const Route = createFileRoute('/$slug/organization/departments/bulk-upload')({
  component: CreateDepartmentsBulkPage
});
